import { render, staticRenderFns } from "./Local.vue?vue&type=template&id=8cc44a10&scoped=true"
import script from "./Local.vue?vue&type=script&lang=js"
export * from "./Local.vue?vue&type=script&lang=js"
import style0 from "./Local.vue?vue&type=style&index=0&id=8cc44a10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc44a10",
  null
  
)

export default component.exports